export default {
  trendingApps: [
    {
      text: 'App Name',
      dataField: 'app_name',
      sortable: true,
      sortBy: 'name',
    },
    {
      text: 'Last 24 hours +/-',
      dataField: 'last_24_hours',
      sortable: true,
      sortBy: 'last_24_hours_row',
    },
    {
      text: 'Current Rank',
      dataField: 'rank',
      sortable: true,
      sortBy: 'rank',
    },
    {
      text: '7 Days Ago',
      dataField: 'rank_7_days_ago',
      sortable: true,
      sortBy: 'rank_7_days_ago_row',
    },
  ],
};
